import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "info-overlay-container",
  id: "weather-forecast-container"
}
const _hoisted_2 = {
  key: 0,
  class: "time-location"
}
const _hoisted_3 = { class: "omf-hl" }
const _hoisted_4 = { class: "omf-hl" }
const _hoisted_5 = {
  key: 1,
  class: "time-location"
}
const _hoisted_6 = {
  key: 2,
  class: "forecast-table-div"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "forecast-table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "acknowledgement" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h1", null, "Forecast", -1)),
    (_ctx.time !== null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createTextVNode(" for " + _toDisplayString(_ctx.time.toLocaleDateString(undefined, {month: 'long', day: 'numeric', timeZone: _ctx.timezone})) + " at ", 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.localTimeString), 1),
          _cache[1] || (_cache[1] = _createTextVNode(", the hour of max eclipse at ", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.locationStr), 1)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, " Not provided for locations where the eclipse is not visible")),
    (_ctx.time !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.forecastForHour === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_icon, { size: "35" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-cloud-cancel", -1)
                  ]))]),
                  _: 1
                }),
                _cache[3] || (_cache[3] = _createElementVNode("div", null, "No data for this hour", -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", null, _toDisplayString(_ctx.forecastForHour.time), 1),
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("td", null, "Cloud cover:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.forecastForHour.cloud_cover) + "%", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Temperature:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.cfPref === 'C' ? _ctx.forecastForHour.temperature_2m : _ctx.celsiusToFahrenheit(_ctx.forecastForHour.temperature_2m)) + "°" + _toDisplayString(_ctx.cfPref), 1)
                    ]),
                    (_ctx.forecastForHour.precipitation_probability !== undefined)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                          _cache[6] || (_cache[6] = _createElementVNode("td", null, "Precipitation Probability:", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.forecastForHour.precipitation_probability) + "%", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.forecastForHour.precipitation !== undefined)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                          _cache[7] || (_cache[7] = _createElementVNode("td", null, "Precipitation:", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.forecastForHour.precipitation) + " mm", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])),
          _createVNode(_component_v_btn_toggle, {
            class: "mt-3 align-center",
            modelValue: _ctx.cfPref,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cfPref) = $event)),
            color: "#eac402",
            density: "compact",
            divided: "",
            mandatory: "",
            "hide-details": "",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                value: "C",
                size: "small",
                height: "2em"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("°C", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                value: "F",
                size: "small",
                height: "2em"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("°F", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", null, [
        _cache[12] || (_cache[12] = _createTextVNode(" Forecast powered by ", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("a", {
          href: "https://open-meteo.com",
          target: "_blank"
        }, "Open-Meteo", -1)),
        _cache[14] || (_cache[14] = _createTextVNode(" using ", -1)),
        (_ctx.openMeteoApi==='gfs')
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [...(_cache[10] || (_cache[10] = [
              _createTextVNode("NOAA GFS (", -1),
              _createElementVNode("a", {
                href: "https://www.ncei.noaa.gov/products/weather-climate-models/global-forecast",
                target: "_blank"
              }, "Global", -1),
              _createTextVNode(" & ", -1),
              _createElementVNode("a", {
                href: "https://rapidrefresh.noaa.gov/hrrr/",
                target: "_blank"
              }, "HRRR", -1),
              _createTextVNode(") forecast models. ", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[11] || (_cache[11] = [
              _createTextVNode("the ", -1),
              _createElementVNode("a", {
                href: "https://www.ecmwf.int/en/forecasts/datasets/open-data",
                target: "_blank"
              }, "ECMWF", -1),
              _createTextVNode(),
              _createElementVNode("a", {
                href: "https://open-meteo.com/en/docs/ecmwf-api",
                target: "_blank"
              }, "3hr", -1),
              _createTextVNode(" forecast model. ", -1)
            ]))]))
      ])
    ])
  ]))
}